/**
 * 全局常量配置
 */

// SSE 长连接接口路径（相对路径，会自动拼接 VITE_API_BASE_URL）
export const SSE_EVENTS_URL = "/sse/events";
